/**
 * useTable
 * `useTable` is the root hook for the `Table` component.
 * To use it, pass it with an options object with at least a `columns` and `data` value,
 * followed by any React Table compatible hooks you want to use.
 *
 * api is inspired by react-table
 * https://react-table.tanstack.com/docs/api/useTable
 */
var getColumnWidth = function (value) {
    if (value === undefined)
        return "1fr";
    if (typeof value === "number")
        return "".concat(value, "fr");
    return value;
};
// eslint-disable-next-line @typescript-eslint/ban-types
var getColumnsTemplate = function (columns) {
    return columns.map(function (col) { return getColumnWidth(col.width); }).join(" ");
};
// eslint-disable-next-line @typescript-eslint/ban-types
var useTable = function () {
    var getTableProps = function (columns) {
        return {
            columnsTemplate: getColumnsTemplate(columns),
        };
    };
    return { getTableProps: getTableProps };
};

export { useTable };
//# sourceMappingURL=useTable.js.map
